import React from "react";
import { Box } from "@mui/material";
import InsightsScreen from "./InsightScreen";

const InsightsOverview: React.FC = () => {
  return (
    <Box sx={{px: "10px", mt: 10.5 }}>
      <InsightsScreen />
    </Box>
  );
};

export default InsightsOverview;
